/**------------------------------------------------------
 * Type Definitions
 */
export type TypeCsvArray = Array<(string | number)[]>;
export type TypeStringMap<T = string> = Record<string, T>;
export type TypeCsvRowData = Record<string, string | boolean | number>;
